import { UploadCover } from './UploadCover'
import { withUploadCover } from './withUploadCover'

const ConnectedUploadCover = withUploadCover(UploadCover)

export { ConnectedUploadCover as UploadCover }
